<template>
  <el-dialog :title="'筛选历史数据'" visible="true">
    <el-form label-width="80px" :model="editForm" :rules="rules" ref="editForm">
      <el-form-item label="时间类型" prop="dateType">
        <el-radio-group v-model="editForm.dateType">
          <el-radio :label="'date'">日期</el-radio>
          <!-- <el-radio :label="'week'">周</el-radio> -->
          <el-radio :label="'month'">月份</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="日期" prop="date">
        <el-date-picker
          v-if="editForm.dateType == 'month'"
          v-model="editForm.date"
          type="month"
          placeholder="选择月"
        >
        </el-date-picker>
        <el-date-picker
          v-model="editForm.date"
          type="date"
          placeholder="选择日期"
          v-else
        >
        </el-date-picker>

        <!-- <el-date-picker
          v-model="value1"
          type="week"
          format="yyyy 第 WW 周"
          placeholder="选择周"
        >
        </el-date-picker> -->
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">取消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        class="title"
        @click="submitForm"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import formatDate from "../../../utils/formatDate"
export default {
  data() {
    return {
      editForm: { dateType: "date", date: new Date() },
      title: "修改计划",
      format:"yyyy-MM-dd",
      rules: {
        dateType: {
          required: true,
          message: "请选择日期类型",
          trigger: "blur",
        },
        date: { required: true, message: "请选择日期", trigger: "blur" },
      },
    };
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    submitForm() {
      this.$refs.editForm.validate((res) => {
        if (res) {
          let start_date=""
          let end_date=""
         
           if(this.editForm.dateType=="date"){
            this.editForm.date=formatDate(new Date(this.editForm.date),"YYYY-MM-DD")
            start_date=this.editForm.date
            end_date=start_date
          }else {
             this.editForm.date=formatDate(new Date(this.editForm.date),"YYYY-MM")
            start_date=this.editForm.date+"-01"
            end_date=this.editForm.date+"-31"
          }
          this.$emit("save", {start_date,end_date});
        }
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/produceDataManage/pop/filterHistory.vue